import { ReactComponent as MoreIcon } from 'assets/icons/settings/more.svg';
import { ReactComponent as Setting2Icon } from 'assets/icons/settings/setting-2.svg';
import { ReactComponent as ToggleOnIcon } from 'assets/icons/settings/toggle-on.svg';

export const settings = {
  more: MoreIcon,
  'setting-2': Setting2Icon,
  'toggle-on': ToggleOnIcon,
};
